import { Outlet } from "react-router";

export default function EBAMLayout() {
    return <Outlet />;
}
